import { useEffect, useState } from 'react'
import { checkDiscountCode } from '../libs/CloudFunctionsApiHandler'
import { DiscountCode } from '../../../pure-js/types/DiscountCodeTypes'

export type UseDiscountCodeInput = {
  clientId: string
  code: string
}

export type UseDiscountCodeResult = {
  data: DiscountCode | null
  error: 'invalid-input' | 'code-invalid' | 'fetch-error' | ''
  isValid: boolean
}

export const validateDiscountCode = async (clientId: string, code: string): Promise<UseDiscountCodeResult> => {
  // Input validation
  if (!clientId || !code) {
    return {
      isValid: false,
      data: null,
      error: 'invalid-input'
    }
  }

  try {
    const result = await checkDiscountCode({ clientId, code })

    if (result) {
      return {
        isValid: true,
        data: result,
        error: ''
      }
    } else {
      return {
        isValid: false,
        data: null,
        error: 'code-invalid'
      }
    }
  } catch (error) {
    console.error('Error validating discount code:', error)
    return {
      isValid: false,
      data: null,
      error: 'fetch-error'
    }
  }
}

export const getDiscountCode = (data: UseDiscountCodeInput): UseDiscountCodeResult => {
  const { clientId, code } = data
  const [error, setError] = useState<'invalid-input' | 'code-invalid' | 'fetch-error' | ''>('')
  const [discountCodeData, setDiscountCodeData] = useState<DiscountCode | null>(null)
  const [isValid, setIsValid] = useState<boolean>(false)

  useEffect(() => {
    let isMounted = true

    const fetchDiscountCode = async () => {
      const result = await validateDiscountCode(clientId, code)

      if (isMounted) {
        setDiscountCodeData(result.data)
        setError(result.error)
        setIsValid(result.isValid)
      }
    }

    fetchDiscountCode()

    return () => {
      isMounted = false
    }
  }, [clientId, code])

  return { data: discountCodeData, error, isValid }
}
